// extracted by mini-css-extract-plugin
export default {"button":"button_button__k8E-j","icon":"button_icon__U+3Hy"};